import { FedInfoFeature } from "../interfaces/fed-info-feature";

export const FEDINFO_FEATURE_INIT_VALUES: FedInfoFeature = {
    showInternalOrder: false,
    internalOrderLabel: 'Internal Order',
    billingCodeDropdown: 'Order Code',
    showBillingCodeDropdown: false,
    showWbs: false,
    wbsLabel: '',
    showDeliveryComments: false,
    deliveryCommentslabel: '',
    showOrderComments: false,
    orderCommentsLabel: '',
    showOrderNotes: false,
    orderNotesLabel: '',
    showProductCode: false,
    productCodeLabel: '',
    showOnDemand: false,
    onDemandLabel: '',
    showOnDemandOrders: false,
    onDemandOrdersLabel: '',
    showOrderWindow: false,
    orderWindowLabel: '',
    showOrderWindowOrders: false,
    orderWindowOrdersLabel: '',
    showPlaningComments: false,
    planningCommentsLabel: '',  
}